import React from 'react';
import Statistics from './Statistics';

const Analytics = () => {
  return <Statistics tab="analytics" />;
};

export default Analytics;
